import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { FoxIcon } from '../components/Brand';
import { TryFreeLink } from '../components/TryFreeLink';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { pricing } from '../lib/pricing';
const linkClass = 'inline-flex items-center gap-2 rounded-lg font-display text-[18px] text-ink underline decoration-coral decoration-[3px] underline-offset-[6px]';
export function NotFound() {
  return <section aria-labelledby="not-found-heading" className="bg-lavender" data-id="element-384" data-mp="1a27v287fzlez">
      <div className="mx-auto max-w-content px-5 pb-24 pt-10 sm:px-6 md:pb-32 md:pt-14" data-id="element-385" data-mp="1f1asb6h6knce">
        <Breadcrumbs label="Page not found" data-id="element-386" data-mp="1judoznh98cwt" />
        <div className="mx-auto mt-12 max-w-xl text-center md:mt-16" data-id="element-387" data-mp="1nv7bqdiynlo4">
          <FoxIcon className="mx-auto h-20 w-20" data-id="element-388" data-mp="1nxjq6gpifdwf" />
          <h1 id="not-found-heading" className="mt-6 font-display text-[38px] leading-[1.08] tracking-tight text-ink md:text-[54px]" data-id="element-389" data-mp="1svbj9e1w5627">
            This page wandered off.
          </h1>
          <p className="mt-4 text-[18px] text-ink/80" data-id="element-390" data-mp="1nwn5l62z5b6b">
            The link may be old or mistyped. Here are a few good places to go instead.
          </p>
          <div className="mt-8 flex flex-col items-center gap-5" data-id="element-391" data-mp="1euw1g5o31cek">
            <TryFreeLink data-id="element-392" data-mp="1ex9vcb710ikj" />
            <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-8" data-id="element-393" data-mp="19w2qajw9pxhk">
              <Link to="/" className={linkClass} data-id="element-394" data-mp="19yfgfkc6je5p">
                Go to the homepage
              </Link>
              <Link to="/worlds" className={`group ${linkClass}`} data-id="element-395" data-mp="22kqean8ej0yt">
                Explore all {pricing.worldCount} worlds
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-396" data-mp="1xti1ribryzhf" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}